import React, { useState } from 'react';

import { Box, Tab, TabPanel, Tabs } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';

import Inverters from './Inverters';
import Panels from './Panels';

const Products = ({ disabled, initialValues, setValue }) => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState('panels');
    const handleChange = (_, newValue) => setSelectedTab(newValue);

    return (
        <React.Fragment>
            <Box>
                <Tabs
                    onChange={handleChange}
                    scrollButtons="auto"
                    value={selectedTab}
                    variant="scrollable"
                >
                    <Tab
                        id="tab-panels"
                        key="tab-panels"
                        label={t('Panels')}
                        value="panels"
                    />
                    <Tab
                        id="tab-inverters"
                        key="tab-inverters"
                        label={t('Inverters')}
                        value="inverters"
                    />
                </Tabs>
            </Box>

            <TabPanel key="tab-panels" selectedTab={selectedTab} value="panels">
                <Panels
                    disabled={disabled}
                    initialValues={initialValues}
                    setValue={setValue}
                />
            </TabPanel>

            <TabPanel
                key="tab-inverters"
                selectedTab={selectedTab}
                value="inverters"
            >
                <Inverters
                    disabled={disabled}
                    initialValues={initialValues}
                    setValue={setValue}
                />
            </TabPanel>
        </React.Fragment>
    );
};

const mapStateToProps = createStructuredSelector({
    pagination: selectors.getPanelsPagination,
    panels: selectors.getPanelsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPanels: (filter, page) => dispatch(actions.fetchPanels(filter, page)),
});

Products.propTypes = {
    disabled: PropTypes.bool,
    initialValues: PropTypes.object,
    setValue: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Products);
